import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FieldArray } from "react-final-form-arrays";
import * as actions from '../../actions';
import { isRequiredSelectionCheckbox } from '../helpers/Validation';
import { camelCase } from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import dividerSvg from '../../divider.svg';
import humanBrainSvg from '../../assets/images/drp-what-is-pd-psychosis.svg';

class Step3 extends Component {
    
    CheckboxGroup = ({ meta, fields, options }) => {
        const toggle = (event, option) => {
            if (event.target.checked) {
                if(option === "Prefer not to say") {  
                    fields.map((name, index) => {
                        this.props.questionAnswer(camelCase(fields.value[index]) + "Checked", false);
                        fields.remove(name);       
                    });
                }
                fields.push(option);
            }
            else {
                fields.remove(fields.value.indexOf(option));
            }
        };
        return (
            <Fragment>
                {meta.error && meta.touched && meta.error }
                {options.map(option => {
                    return (
                        <div key={option} className="relative form-group">   
                            <label className="inline-checkboxes">   
                                <input
                                    name={camelCase(option)}
                                    type="checkbox" 
                                    value={option}
                                    onClick={event => toggle(event, option)}
                                    defaultChecked={this.props.questionOptions[camelCase(option + "Checked")]}
                                    key={this.props.questionOptions[camelCase(option + "Checked")]}   
                                />
                                <span>{option}</span>
                            </label>
                        </div>   
                    );
                })}
            </Fragment>
        );
    }
        
    render() {
        const { otherChecked, userType } = this.props.questionOptions;
        
        const caregiverOptions = [
            "Seeing people, animals, or objects that aren't there",
            "Hearing voices or sounds that others don't",
            "Feeling a burning or tingling of the skin without being touched",
            "Smelling unusual or unpleasant odors that aren't there",
            "Other",
            "Prefer not to say"
        ];

        const patientOptions = [
            "Seeing people, animals, or objects that I'm told aren't there",
            "Hearing voices or sounds that others don't",
            "Feeling a burning or tingling of the skin without being touched",
            "Smelling unusual or unpleasant odors that I'm told aren't there",
            "Other",
            "Prefer not to say"
        ];

        const hallucinationOptions = userType === "caregiver" ? caregiverOptions : patientOptions;

        return (
            <Fragment>
                <img src={humanBrainSvg} className="overlay-image" />
                <div className="form-group">
                    <div className="grid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="h1">
                                    {userType === "caregiver" ? 
                                        ReactHtmlParser("<span>Which of these hallucinations has your loved&nbsp;one&nbsp;experienced?</span>")
                                        : "Which of these hallucinations have you experienced?"
                                    }
                                </h1>  
                                <span className="instructions">Select all that apply</span>
                                <img src={dividerSvg} alt="divider" />
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <FieldArray
                                            name="hallucinationOptions"
                                            component={this.CheckboxGroup}
                                            options={hallucinationOptions}
                                            validate={isRequiredSelectionCheckbox}
                                            key={otherChecked}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
}
  
export default connect(mapStateToProps, actions)(Step3);
